import { render, staticRenderFns } from "./IndexBankSoal.vue?vue&type=template&id=52ff2166"
import script from "./IndexBankSoal.vue?vue&type=script&lang=js"
export * from "./IndexBankSoal.vue?vue&type=script&lang=js"
import style0 from "./IndexBankSoal.vue?vue&type=style&index=0&id=52ff2166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports